import React from 'react';
import { PathStageChips } from './PathStageChips';
import { StatusBadge } from './StatusBadge';
import { cn } from '../../lib/utils';
import { useTheme } from '../../context/ThemeContext';

const INCOMPLETE_BAR_STYLE = {
  backgroundImage:
    'repeating-linear-gradient(-45deg, #CBD5E1, #CBD5E1 4px, #F8FAFC 4px, #F8FAFC 8px)',
};

function formatShare(share) {
  return `${(share * 100).toFixed(1)}%`;
}

export function PathRow({
  path,
  rank,
  maxShare = 1,
  selected = false,
  onSelect,
}) {
  const { chartPalette } = useTheme();
  const barTone = path.barTone || 'primary';
  const relative = maxShare > 0 ? path.share / maxShare : 0;

  let barClass = '';
  let barColor;
  if (barTone === 'success') {
    barClass = 'bg-emerald-600';
  } else if (barTone === 'incomplete') {
    barClass = '';
  } else {
    barColor = chartPalette[(rank - 1) % chartPalette.length];
  }

  const barStyle = {
    width: `${Math.max(relative * 100, 4)}%`,
    ...(barTone === 'incomplete' ? INCOMPLETE_BAR_STYLE : null),
    ...(barColor ? { backgroundColor: barColor } : null),
  };

  return (
    <button
      type="button"
      onClick={() => onSelect?.(path.id)}
      className={cn(
        'w-full rounded-xl border px-3 py-3 text-left transition sm:px-4',
        selected
          ? 'border-[var(--brand-primary,#1A428A)] bg-[var(--brand-primary,#1A428A)]/[0.05] shadow-sm ring-1 ring-[var(--brand-primary,#1A428A)]/20'
          : 'border-slate-100 bg-white hover:border-slate-200 hover:bg-slate-50/70'
      )}
      aria-pressed={selected}
    >
      <div className="flex items-center gap-3">
        <span className="w-5 shrink-0 text-xs font-semibold tabular-nums text-slate-400">
          {rank}
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <PathStageChips stages={path.stages} />
            <StatusBadge tone={path.badge} />
          </div>
          {/* Flow-width bar: proportional to largest path for clearer hierarchy */}
          <div className="mt-2.5 h-3.5 overflow-hidden rounded-md bg-slate-100">
            <div className={cn('h-full rounded-md transition-all', barClass)} style={barStyle} />
          </div>
        </div>
        <div className="shrink-0 text-right">
          <p className="text-base font-bold tabular-nums text-[#201C35]">{formatShare(path.share)}</p>
          <p className="text-[11px] tabular-nums text-slate-500">
            {path.count.toLocaleString('en-US')}
          </p>
        </div>
      </div>
    </button>
  );
}
